/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputMapZoneDataItem
 */
export interface OutputMapZoneDataItem {
    /**
     * 
     * @type {string}
     * @memberof OutputMapZoneDataItem
     */
    coords: string;
    /**
     * 
     * @type {string}
     * @memberof OutputMapZoneDataItem
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof OutputMapZoneDataItem
     */
    radius: number;
    /**
     * 
     * @type {string}
     * @memberof OutputMapZoneDataItem
     */
    type: string;
}

/**
 * Check if a given object implements the OutputMapZoneDataItem interface.
 */
export function instanceOfOutputMapZoneDataItem(value: object): boolean {
    if (!('coords' in value)) return false;
    if (!('name' in value)) return false;
    if (!('radius' in value)) return false;
    if (!('type' in value)) return false;
    return true;
}

export function OutputMapZoneDataItemFromJSON(json: any): OutputMapZoneDataItem {
    return OutputMapZoneDataItemFromJSONTyped(json, false);
}

export function OutputMapZoneDataItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputMapZoneDataItem {
    if (json == null) {
        return json;
    }
    return {
        
        'coords': json['coords'],
        'name': json['name'],
        'radius': json['radius'],
        'type': json['type'],
    };
}

export function OutputMapZoneDataItemToJSON(value?: OutputMapZoneDataItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'coords': value['coords'],
        'name': value['name'],
        'radius': value['radius'],
        'type': value['type'],
    };
}

